let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gMamG")).then(() => parcelRequire('kbmIh'));